import React from 'react';
import classnames from 'classnames';
import './index.scss';
export default function OPInfoCard(props) {
    const { data, className, columns = 3 } = props;
    return (React.createElement("div", { className: classnames('op-info-card', className, {
            [`op-info-card-col-${columns}`]: columns,
        }) }, data.map((item, index) => (React.createElement("div", { key: index, className: 'op-info-card-item' },
        React.createElement("div", { className: 'op-info-card-label' }, item.label),
        React.createElement("div", { className: 'op-info-card-value' }, item.value))))));
}
